import styled from "styled-components";
import Head from "./HeaderHemo/Head";
import NavBar from "./NavBar/NavBar";
import Content from "./Content/Content";
import { PageProvider } from "./Context/PageContext";
import { useContext } from "react";
import FooteBan from "./FooterBan/FooterBan";


function Main() {
    return(
        <MasterContainer>
            <PageProvider>
                <Head/>
                <Content/>
                <FooteBan/>
            </PageProvider>
        </MasterContainer>
    )
}

export default Main;

const MasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    //border: solid 1px;
    min-height: 100vh;
`